<template>
    <div class="megagameBanner">
        <div class="megagame-name">
            {{megagameName}}
        </div>

        <div class="big-banner"
            @click="bigBanner.createType === '标准模式' ? goDetailPage(datailPath,bigBanner) : golink(bigBanner.url) ">
            <p class="big-banner-name" :title="bigBanner.name">{{bigBanner.name | limitWordText(69)}}</p>
            <img :src="bigBanner.banner" alt="">
        </div>

        <div class="banners">
            <div class="banner"
                v-for="(item,index) in banners"
                :key="index"
                @click="item.createType === '标准模式' ? goDetailPage(datailPath,item) : golink(item.url) ">
                <p class="banner-name" :title="item.name">{{item.name | limitWordText(32)}}</p>
                <img :src="item.banner" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import mixins from '@/utils/mixin'
export default {
  name: 'megagameBanner',
  mixins: [mixins],
  props: {
    megagameName: String, // 历届活动标题名
    bigBanner: Object, // 大横幅
    banners: Array, // 所有活动横幅
    datailPath: String // 活动详情连接
  },
  components: {

  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    // 跳转详情页
    goDetailPage (path, item) {
      // sessionStorage.setItem('activityDetail', JSON.stringify(item))
      // this.$router.push(path)
      this.$router.push({ path: path, query: { id: item.id } }) // 跳转大赛详情
      // console.log(path, item)
    },

    // 跳转配置连接页
    golink (path) {
      if (path === null) { return }

      if (path.indexOf('https://') !== -1) {
        path.replace('https://', 'http://')
        window.open(path)
      } else if (path.indexOf('http://') !== -1) {
        window.open(path)
      } else {
        window.open('http://' + path)
      }
    }
  }
}
</script>

<style scoped lang="less">
.megagameBanner{
    width: 1200px;
    overflow: hidden;
}
.megagame-name{
    box-sizing: border-box;
    margin: 22px 0;
    padding: 0 20px;
    border-left: 5px solid #1076EC;
    border-radius: 2px 0 0 2px;
    font-size: 20px;
    font-weight: 600;
}
.big-banner{
    position: relative;
    width: 100%;
    height: 379px;
    box-sizing: border-box;
    padding: 0 20px;
    margin-bottom: 24px;
    cursor: pointer;
    .big-banner-name{
        position: absolute;
        bottom: 0;
        width: 1160px;
        height: 44px;
        line-height: 44px;
        box-sizing: border-box;
        padding-left: 33px;
        background-color: rgba(0, 0, 0, 0.44);
        border-radius: 0px 0px 10px 10px;
        color: #fff;
        font-size: 16px;
    }
    img{
        width: 1160px;
        height: 379px;
        border-radius: 10px;
    }
}
.banners{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    min-height: 50vh;
    box-sizing: border-box;
    padding: 0 20px 36px;
    cursor: pointer;
    .banner{
        position: relative;
        width: 571px;
        height: 188px;
        border-radius: 10px;
        margin-bottom: 22px;
        .banner-name{
            position: absolute;
            bottom: 0;
            width: 571px;
            height: 44px;
            line-height: 44px;
            box-sizing: border-box;
            padding-left: 33px;
            background-color: rgba(0, 0, 0, 0.44);
            border-radius: 0px 0px 10px 10px;
            color: #fff;
            font-size: 16px;
        }
        img{
            width: 571px;
            height: 188px;
            border-radius: 10px;
        }
    }
}
</style>
